import { useClientAnalytics } from '@ilteducation/client-analytics';
import type { CloseEndedQuestion, Exercise } from '@ilteducation/exercise-service-types';
import { videoSessionId } from '@/composables/use-video-session';

/** Matches the entries the quiz store builds in setCorrectAnswers; questionId is the content index. */
type GradedAnswer = {
  questionId: number;
  optionId: string;
  correctOptionId: string;
  correct: boolean;
};

const questionKey = (question: CloseEndedQuestion, quizId: string, index: number) =>
  question.id ?? `${quizId}:${index}`;

/** One event per question, sent once when the user reveals their result. */
export function trackQuizResults(quiz: Exercise, gradedAnswers: GradedAnswer[]): void {
  const { sendAnalyticsEvent } = useClientAnalytics();

  gradedAnswers.forEach(({ questionId: questionIndex, optionId, correctOptionId, correct }) => {
    const question = quiz.content[questionIndex];
    if (question?.type !== 'closed-question') {
      return;
    }
    const optionValue = (id: string) => question.options.find((option) => option.id === id)?.value;

    sendAnalyticsEvent('AppUserEventType', {
      eventName: 'quiz_question_answered',
      metadata: {
        videoId: quiz.resourceId,
        videoSessionId: videoSessionId.value,
        quizId: quiz.id,
        questionId: questionKey(question, quiz.id, questionIndex),
        questionIndex,
        questionPhrase: question.phrase,
        answeredOptionId: optionId,
        answeredOptionValue: optionValue(optionId),
        correctOptionId,
        correctOptionValue: optionValue(correctOptionId),
        isCorrect: correct,
      },
    });
  });
}
